import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'
import type { Voip } from '@brighterly/lib-core-types/support/enums'

import { useDisciplineStore } from '@stores/discipline'
import { useKidStore } from '@stores/kid'

import { useActiveKidDisciplinesApi } from '@api/kids/active-kid-disciplines.hook'
import { useKidInCustomer } from '@hooks/kid/kid-in-customer.hook'

export const useMiddlewareBookingVoip = async (booking: Booking | null): Promise<Voip | null> => {
  const disciplineStore = useDisciplineStore()
  const kidStore = useKidStore()

  const activeVoip = disciplineStore.activeDiscipline?.voip

  if (activeVoip) {
    return activeVoip
  }

  const { kid } = useKidInCustomer({ kidId: kidStore.activeKidId })
  const customerVoip = kid.value?.disciplines.find(discipline => discipline.code === booking?.discipline)?.voip

  if (customerVoip) {
    return customerVoip
  }

  const disciplines = await useActiveKidDisciplinesApi()
  const disciplineInfo = disciplines?.find(discipline => discipline.code === booking?.discipline)
    ?? disciplines?.find(discipline => discipline.id === disciplineStore.activeDiscipline?.id)

  return disciplineInfo?.kid.voip ?? null
}
